import { US_AREA_CODES } from '@/modules/Socket';

export const validateUSPhone = (_: any, value: string) => {
  const digits = value.replace(/\D/g, '');
  const phone = digits.replace(/^1/, '');
  const areaCode = parseInt(phone.slice(0, 3), 10);
  
  if (phone.length !== 10) return Promise.reject('Required');
  if (!US_AREA_CODES.has(areaCode)) return Promise.reject('Invalid US area code');
  return Promise.resolve();
};
